

module.exports = __webpack_require__.stylable.create(
    "OfferingView2314191375",
    {"classes":{"root":"OfferingView2314191375__root","OverlappingMediaContainer":"OverlappingCard3695102127__mediaContainer","ClassicCardMediaContainer":"LegacyCard1961987786__mediaContainer","StripCardMediaContainer":"StripCard3696396491__mediaContainer","overlapping":"OfferingView2314191375__overlapping","OverlappingCardInfoContainer":"OverlappingCard3695102127__infoContainer","classic":"OfferingView2314191375__classic","ClassicCardInfoContainer":"LegacyCard1961987786__infoContainer","strip":"OfferingView2314191375__strip","grid":"OfferingView2314191375__grid","ClassicCardDeprecated":"LegacyCard1961987786__deprecated"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    4,
    "OfferingView2314191375",
    null
);
